export const LOGBOX_ACADEMIC = 'LogBox Academic'

export const LOGBOX_ACADEMIC_URL = 'www.logbox.co.za/#/academic'

export const LOGBOX_PRACTICE = 'LogBox Practice'

export const LOGBOX_PRACTICE_URL = 'www.logbox.co.za/#/practice'
